import StBlock from './StBlock';

/**
 * Display declaration and implementation sections
 */
const DeclarationImplementationBlock = ({ title, declaration, implementation }) => {
  return (
    <>
      {(title || declaration || implementation) && (
        <div className="declaration-implementation-block">
          {title && <h3>{title}</h3>}
          <StBlock code={declaration} />
          {implementation && (
            <>
              <hr />
              <StBlock code={implementation} />
            </>
          )}
        </div>
      )}
    </>
  );
};

export default DeclarationImplementationBlock;
